export default (element, disabled = false) => {
  let copyText = document.getElementById(element);
  if (disabled) copyText.disabled = false;

  /* Select the text field */
  copyText.select();

  /* Copy the text inside the text field */
  document.execCommand("copy");

  // copyText.setAttribute("disable", true);
  copyText.blur();

  if (disabled) copyText.disabled = true;
};
